<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <h3
        class="kds-typography-title-xlarge"
        v-html="$t('b2b_self_test_fear_of_movement_question')"
      />
      <ScoreSlider
        :label="getFearOfMovementLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_fear_of_movement_max')"
        :min-text="$t('b2b_self_test_fear_of_movement_min')"
        :score="getFearOfMovementValue"
        data-q-a="score-slider"
        @change="handleFearOfMovementChange"
        @tap="handleFearOfMovementChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import { computed } from 'vue'

const selfTestStore = useSelfTestStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const initialFearOfMovement = computed(
  () => selfTestStore.initialFearOfMovement,
)

const getFearOfMovementValue = computed(() =>
  initialFearOfMovement.value === -1 ? 5 : initialFearOfMovement.value,
)

const getFearOfMovementLabel = computed(() =>
  initialFearOfMovement.value === -1 ? '' : `${initialFearOfMovement.value}`,
)

const isValid = computed(
  () => initialFearOfMovement.value >= 0 && initialFearOfMovement.value <= 10,
)

const handleFearOfMovementChange = ({ value }) => {
  selfTestStore.initialFearOfMovement = value
}
</script>
